<template>
    <form @submit.prevent="submitForm">
        <h2 v-t="'aftersubmit.heading'"/>
        <div class="remarks">
            {{ $t('aftersubmit.info') }}<br/>
            {{ $t('aftersubmit.number') }} <span>{{number}}</span>
        </div>
        <input type="submit" :value="$t('aftersubmit.controls.back_button')"/>
    </form>
</template>

<script>
import {eventBus} from "@/main";

export default {
    name: 'AfterSubmitPage',
    props: ['number'],
    methods: {
        submitForm() {
            eventBus.$emit('newForm')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
    font-size: 1.25em;
    font-weight: 600;
    line-height: 1.2em;
    margin-bottom: 0.6em;
}

strong {
    font-weight: 600;
    margin-bottom: 1em;
    display: block;
}

.remarks {
    margin-bottom: 1em;
}

label {
    width: auto;
    font-weight: 600;
    line-height: 1.4em;
    padding-right: 0.5em;
    margin: 0;
}

input {
    width: 96%;
    height: 1.65em;
    font-size: 1.188em;
    font-weight: 400;
    padding: 0 2%;
    margin-top: 0.3em;
    margin-bottom: 0.6em;
    background-color: transparent;
    border: 1px solid #888
}

input:focus {
    border: 1px solid #000;
}

/* The container */
.container {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    font-size: 0.938em;
    font-weight: 400;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-top: 0.3em;
}

/* Hide the browser's default radio button */
.container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 17px;
    width: 17px;
    background: url(https://www.th-koeln.de/img/icons/select-default.svg);
    border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
    background: url(https://www.th-koeln.de/img/icons/select-active.svg);
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
    background: url(https://www.th-koeln.de/img/icons/select-active.svg);
}

select {
    width: 100%;
    height: 1.65em;
    font-size: 0.938em;
    font-weight: 400;
    padding: 0.325em 0;
    margin-top: 0.3em;
    margin-bottom: 0.6em;
    background-color: transparent;
    border: 1px solid #888;
    box-sizing: content-box;
}

select:focus {
    border: 1px solid #000;
}

textarea {
    width: 96%;
    height: 7.08em;
    font-size: 0.938em;
    font-weight: 400;
    padding: 0.625em 2%;
    margin-top: 0.3em;
    margin-bottom: 0.6em;
    background-color: transparent;
    border: 1px solid #888
}

textarea:focus {
    border: 1px solid #000;
}

input[type=submit] {
    font-size: 1.188em;
    font-weight: 600;
    background: url(https://www.th-koeln.de/img/icons/link-intern.svg) no-repeat right .5em;
    background-size: 12px 12px;
    line-height: normal;
    width: 100%;
    text-align: right;
    margin-bottom: 0.5em;
    padding-right: 0.9em;
    border: 0;
    float: right;
    cursor: pointer;
}

hr {
    border: 0;
    border-top: 1px solid #ccc;
    clear: both;
    display: block;
    height: 1px;
    margin: 1em 0;
    padding: 0;
}
</style>